import {getCurrentYear} from '../../utils/commons'
import BestOnlineReviewsLogo from './logo'
import {bestOnlineReviewsStylesIN} from './styles'

const baseConfig = {
  domainName: 'bestonlinereviews' as const,
  domainType: 'eu' as const,
  siteName: 'Best Online Reviews',
  favicon: '/favicons/bestonlinereviews.png',
  styles: bestOnlineReviewsStylesIN,
}

const localeConfigs = {
  in: {
    measurementId: 'G-0YFK6E0EH2',
    camelCaseUrl: 'BestOnlineReviews.in',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the India | Expert Online Reviews | BestOnlineReviews.in`,
    description: (category?: string, _count?: string) =>
      `Find the Best ${category} of ${getCurrentYear()} with BestOnlineReviews.in! Dive into expert comparisons, in-depth reviews - making your decisions smarter and easier`,
    logo: <BestOnlineReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="in" />,
  },
}

export const createConfig = (locale: string = 'in') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.in
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
